import React, { useState } from "react";

const AddFreelancerReviewModel = ({ isOpen, rating, setRating, review, setReview, handleSubmit, IsLoading }) => {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-lg w-full max-w-md p-6">
                <h2 className="text-xl font-semibold mb-4">Add Review</h2>
                <div className="flex flex-col gap-4">
                    <div>
                        <label className="block mb-1 font-medium">Rating</label>
                        <div className="flex space-x-1">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <button
                                    key={star}
                                    type="button"
                                    onClick={() => setRating(star)}
                                    className={`text-2xl ${star <= rating ? "text-yellow-400" : "text-gray-300"
                                        }`}
                                >
                                    ★
                                </button>
                            ))}
                        </div>
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">Review</label>
                        <textarea
                            value={review}
                            onChange={(e) => setReview(e.target.value)}
                            placeholder="Write your review..."
                            className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            rows={4}
                        />
                    </div>
                    <button
                        onClick={() => { handleSubmit() }}
                        className="bg-blue-500 text-white font-medium py-2 rounded-lg hover:bg-blue-600 transition"
                    >
                        {IsLoading ? "Please wait" : "Submit Review"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddFreelancerReviewModel;
